import { Link } from "react-router-dom";

/**
 * Guides roster/placeholder learners who must claim an existing row (same email), not register again.
 */
export default function ExistingAcademyAccountHelp({ email, testIdPrefix = "existing-account" }) {
  return (
    <div className="rounded-md border border-border bg-muted/40 p-4 space-y-3 text-sm" data-testid={`${testIdPrefix}-help`}>
      <p className="font-medium">You already have a GDI Academy account for this email</p>
      <p className="text-muted-foreground">
        Your instructor may have set up your profile before your first login. Use the same email to claim it — we do not
        create a second account.
      </p>
      <ol className="list-decimal list-inside space-y-2 text-muted-foreground">
        <li>
          <Link to="/forgot-password" className="underline font-medium text-foreground" data-testid={`${testIdPrefix}-forgot-link`}>
            Reset your password
          </Link>{" "}
          (if you have never logged in or forgot your password).
        </li>
        <li>After resetting, log in. If prompted, verify your email — resetting your password does not verify email.</li>
        <li>Your published training history and instructor link stay on the same account.</li>
      </ol>
      {email ? (
        <p className="text-xs text-muted-foreground" data-testid={`${testIdPrefix}-email-hint`}>
          Continue with <span className="font-mono">{email}</span>
        </p>
      ) : null}
      <p>
        <Link to="/login" className="underline" data-testid={`${testIdPrefix}-login-link`}>Back to log in</Link>
      </p>
    </div>
  );
}
